'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Get browser language.
 *
 * @return {String} langKey
 */
var getBrowserLanguage = function getBrowserLanguage() {
  if (typeof window === 'undefined') {
    return null;
  }

  var first = window.navigator.languages ? window.navigator.languages[0] : null;

  var lang = first || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

  return lang;
};

exports.default = getBrowserLanguage;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/getBrowserLanguage.js
// module id = 109
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311